// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2mjgHldV1KbsTN-Sd5k8F1","icon":"whHu-jHYoi1sexjRf2rFC","active":"_3TLAUSlDhQtKgAeoYAN7cT"};